<app-custom-mat-table
  [recordCount]="recordCount"
  [dataSource]="dataSource"
  [columns]="myColumns"
  [isLoading]="(products$ | async)?.loading!"
  [pageSizes]="[5]"
></app-custom-mat-table>
